import { Component, EventEmitter, Input, Output } from '@angular/core';

// SD-1137: Reusable tile with a check-state indicator used across the capture-methods
// picker. Supports multi-select (checkbox) and radio (single-select) visuals.
@Component({
  selector: 'app-selectable-card',
  templateUrl: './selectable-card.component.html',
  styleUrls: ['./selectable-card.component.scss']
})
export class SelectableCardComponent {
  @Input() title = '';
  @Input() description = '';
  @Input() iconSrc: string | null = null;
  @Input() selected = false;
  @Input() disabled = false;
  @Input() mode: 'checkbox' | 'radio' = 'checkbox';
  @Output() toggle = new EventEmitter<boolean>();

  onClick(): void {
    if (this.disabled) return;
    this.toggle.emit(!this.selected);
  }
}
